/**
 * Where a drop lands in a column: before the first card whose middle lies below the pointer. Past the last card it is
 * `after`, the task that follows the shown cards (the done column hides the rest behind "weitere anzeigen"), or `null`
 * for the end of the column. The dragged card itself counts: hovering around it means "stay here", which the API treats
 * as no change.
 */
export function dropBefore(cards: ReadonlyArray<{ id: number; middle: number }>, y: number, after: number | null): number | null {
  return cards.find((c) => c.middle > y)?.id ?? after;
}
